module.exports = __webpack_public_path__ + "static/media/absolute.d2c129b6.svg";